module.exports = __webpack_public_path__ + "static/media/samurai.a768a3a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/samurai.jpg
// module id = 82
// module chunks = 0